import anime from 'animejs';
import { bindMethod } from 'helpers/bind';
import detect from 'helpers/detect';
import { EASE_OUT, frameToMs } from 'helpers/easings';
import { clamp } from 'lodash-es';
import Component, { forceArray } from 'navigation/component/Component';
import mqStore from 'store/mqStore';
export default class DragController extends Component {
    x = 0;
    targetX = 0;
    delta = 0;
    _progress = 0;
    itemsVisible = 0;
    currentItem = 0;
    limit = 0;
    start = 0;
    grabbingTimeout = null;
    snappingTimeout = null;
    snaps = false;
    holding = false;
    _draggable = false;
    mouse = {
        x: 0,
        prevX: 0,
        startTime: null
    };
    get progress() {
        return this._progress;
    }
    set progress(value) {
        if (value === 0)
            this.el.classList.remove('left');
        else
            this.el.classList.add('left');
        if (value === 1)
            this.el.classList.remove('right');
        else
            this.el.classList.add('right');
        this._progress = value;
    }
    _grabbing = false;
    _moving = false;
    _native = false;
    get grabbing() {
        return this._grabbing;
    }
    set grabbing(value) {
        this._grabbing = value;
        if (value)
            this.el.classList.add('grabbing');
        else
            this.el.classList.remove('grabbing');
    }
    get moving() {
        return this._moving;
    }
    set moving(value) {
        this._moving = value;
        if (value) {
            this.el.classList.add('moving');
            document.documentElement.classList.add('no-select');
        }
        else {
            this.el.classList.remove('moving');
            document.documentElement.classList.remove('no-select');
            this._grabbing = false;
            this._moving = false;
        }
    }
    get native() {
        return this._native;
    }
    set native(value) {
        if (value) {
            this.delta = 0;
            forceArray(this.refs.draggableItems).forEach((item) => {
                item.style.transform = '';
            });
            this.el.classList.add('native');
            this._native = true;
        }
        else {
            this.el.classList.remove('native');
            this._native = false;
        }
    }
    get draggable() {
        return this._draggable;
    }
    set draggable(value) {
        this._draggable = value;
        this.el.classList.toggle('draggable', value);
    }
    gradient = false;
    constructor(el, options) {
        super(el, options);
        this.itemsVisible = options.itemsVisible || 1;
        this.currentItem = this.itemsVisible;
        this.gradient = options.gradient || false;
        this.snaps = options.snaps || false;
        this.start = options.start || 0;
        if (this.gradient) {
            this.el.classList.add('has-gradient');
            this.el.classList.add('right');
        }
    }
    initialized = () => {
        super.initialized();
        this.onTabletPortrait(mqStore.tabletPortrait.get());
        const current = forceArray(this.refs.draggableItems).find((item) => item?.classList.contains('current'));
        this.resize();
        if (current)
            this.move(current.offsetLeft - 40);
        const mobile = mqStore.tabletPortrait.get();
        if (this.start && this.start > 0) {
            const item = forceArray(this.refs.draggableItems)[mobile ? this.start : this.start - 1];
            if (item) {
                if (!mobile)
                    this.move(item.offsetLeft - 40, true);
                else
                    this.el.children[0].scrollLeft = item.offsetLeft;
            }
        }
    };
    bindEvents(add) {
        const method = bindMethod(add);
        this.el.children[0][method]('wheel', (e) => this.onWheel(e));
        this.el.children[0][method]('scroll', (e) => this.onScroll(e));
        this.el[method]('mousedown', (e) => this.onMouseDown(e));
        window[method]('mousemove', (e) => this.onMouseMove(e));
        window[method]('mouseup', (e) => this.onMouseUp(e));
        mqStore.tabletPortrait.toggleListener(add, this.onTabletPortrait);
    }
    onScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.progress = clamp(this.el.children[0].scrollLeft / (this.el.children[0].scrollWidth - this.el.children[0].clientWidth), 0, 1);
        this.emit('move');
    };
    onWheel = (e) => {
        if (this.native)
            return;
        const absX = Math.abs(e.deltaX);
        const absY = Math.abs(e.deltaY);
        if (absX > absY) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.move(e.deltaX);
        }
    };
    onMouseDown = (e) => {
        if (this.native || !this.draggable)
            return;
        this.mouse = {
            x: e.clientX,
            prevX: e.clientX,
            startTime: Date.now()
        };
        this.holding = true;
    };
    onMouseMove = (e) => {
        if (this.native || !this.draggable)
            return;
        if (this.holding)
            this.grabbing = true;
        if (this.grabbing) {
            if (!this.moving)
                this.moving = true;
            const delta = e.clientX - this.mouse.x;
            this.move(-delta);
            this.mouse.prevX = this.mouse.x;
            this.mouse.x = e.clientX;
        }
    };
    onMouseUp = (e) => {
        clearTimeout(this.grabbingTimeout);
        if (this.native || !this.draggable)
            return;
        this.holding = false;
        if (this.mouse.startTime) {
            if (this.mouse.startTime + 100 < Date.now()) {
                e.preventDefault();
                this.grabbing = false;
                this.moving = false;
            }
        }
    };
    onTabletPortrait = (tabletPortrait) => {
        if (tabletPortrait && detect.touch)
            this.native = true;
        else
            this.native = false;
    };
    move = (delta, force = false) => {
        if (this.limit === 0)
            return;
        if (this.snaps)
            clearTimeout(this.snappingTimeout);
        this.delta = clamp(this.delta - delta, -this.limit, 0);
        forceArray(this.refs.draggableItems).forEach((item) => {
            if (item)
                item.style.transform = `translateX(${this.delta}px)`;
        });
        this.progress = Math.abs(this.delta / -this.limit);
        if (this.itemsVisible > 1)
            this.currentItem = clamp(this.itemsVisible + Math.round(this.progress * (this.refs.draggableItems.length)), this.itemsVisible, this.refs.draggableItems.length);
        else
            this.currentItem = clamp(this.itemsVisible - 1 + Math.round(this.progress * (this.refs.draggableItems.length - 1)), this.itemsVisible - 1, this.refs.draggableItems.length - 1);
        if (this.snaps) {
            this.snappingTimeout = setTimeout(() => {
                this.snapping(force);
            }, 200);
        }
        this.emit('move');
    };
    snapping(force = false) {
        this.progress = this.currentItem / (this.refs.draggableItems.length - 1);
        this.delta = -this.limit * this.progress;
        anime({
            targets: this.refs.draggableItems,
            translateX: this.delta,
            duration: force ? 0 : frameToMs(25),
            easing: EASE_OUT
        });
    }
    navigate = (direction) => {
        const target = clamp(this.currentItem + (this.itemsVisible) * direction, 0, this.refs.draggableItems.length);
        if (target < 0 || target > this.refs.draggableItems.length)
            return;
        if (this.native)
            return;
        const targetProgress = Math.max((target - this.itemsVisible), 0) / (this.refs.draggableItems.length - this.itemsVisible);
        this.delta = -this.limit * targetProgress;
        anime({
            targets: this.refs.draggableItems,
            translateX: this.delta,
            duration: frameToMs(50),
            easing: EASE_OUT
        });
        this.currentItem = target;
        this.progress = targetProgress;
        this.emit('move');
    };
    resize = () => {
        super.resize();
        this.limit = this.el.children[0].scrollWidth - this.el.children[0].clientWidth;
        this.draggable = this.limit > 0;
        this.delta = clamp(this.delta, -this.limit, 0);
        forceArray(this.refs.draggableItems).forEach((item) => {
            if (item)
                item.style.transform = `translateX(${this.delta}px)`;
        });
    };
}
